/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Bell_Activity_Proposals_ManyInputs */

const en_bell_activity_proposals_many = /** @type {(inputs: Bell_Activity_Proposals_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`proposals on ${i?.count} lines`)
};

/**
* | output |
* | --- |
* | "proposals on {count} lines" |
*
* @param {Bell_Activity_Proposals_ManyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_activity_proposals_many = /** @type {((inputs: Bell_Activity_Proposals_ManyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_Activity_Proposals_ManyInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_activity_proposals_many(inputs)
});